function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Icon } from '../../../Icon';
export const DefaultIcon = ({
  src = 'icon-placeholder',
  iconColor,
  ...rest
}) => /*#__PURE__*/React.createElement(Icon.SSR, _extends({
  src: src,
  color: iconColor,
  size: "large",
  "aria-hidden": true
}, rest));